/* Movimiento ligado al scroll y al ratón.
 *
 * Lo que ya había animaba UNA vez al entrar en pantalla y después la página se
 * quedaba quieta: por eso se veía estática. Esto añade lo que sí responde a lo
 * que hace la persona — paralaje, la cinta que acelera al hacer scroll, las
 * tarjetas que se inclinan hacia el cursor y los botones que lo atraen.
 *
 * Un solo bucle de rAF y un solo listener de scroll: primero se lee todo y
 * luego se escribe, para no provocar recálculos de diseño en cada cuadro.
 * Con prefers-reduced-motion no se activa nada.
 */
(function () {
  'use strict';
  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (quieto) return;

  var fino = window.matchMedia('(pointer: fine)').matches;
  var y = window.pageYOffset, yAnt = y, vel = 0;
  var alto = window.innerHeight;
  var pendiente = false;

  /* ---------- barra de progreso ---------- */
  var barra = document.createElement('div');
  barra.className = 'fv-progreso';
  barra.setAttribute('aria-hidden', 'true');
  document.body.appendChild(barra);

  /* ---------- paralaje ---------- */
  var capas = [].slice.call(document.querySelectorAll('[data-vida-parallax]'));
  var frotes = [].slice.call(document.querySelectorAll('[data-vida-scrub]'));
  var cajas = [], escenas = [];
  function medir() {
    alto = window.innerHeight;
    for (var k = 0; k < cintas.length; k++) cintas[k].w = cintas[k].el.scrollWidth / 2;
    cajas = capas.map(function (el) {
      var r = el.getBoundingClientRect();
      return { el: el, top: r.top + window.pageYOffset, h: r.height,
               f: parseFloat(el.dataset.vidaParallax) || 0.12,
               esc: parseFloat(el.dataset.vidaScale) || 0 };
    });
    // scrub al modo Apple/Zara: cada elemento sabe cuanto lleva recorrido.
    //   --p  cuanto ha salido ya por arriba (0 quieto, 1 fuera)
    //   --e  cuanto ha entrado desde abajo (0 aun no, 1 del todo)
    escenas = frotes.map(function (el) {
      var r = el.getBoundingClientRect();
      return { el: el, top: r.top + window.pageYOffset, h: Math.max(r.height, 1), p: -1, e: -1,
               sua: el.hasAttribute('data-vida-suave'), se: 0, seW: -1 };
    });
  }

  /* ---------- cinta acoplada al scroll ----------
     La cinta llevaba una animación CSS a velocidad fija. Al pasarla a
     transform se puede sumar la velocidad del scroll: al bajar acelera y al
     subir frena, que es lo que la hace sentir viva en vez de decorativa. */
  /* La cinta y el rotulo gigante: marquesinas continuas. Velocidad propia
     mas el empujon del scroll, y envuelven a mitad de contenido (las dos
     mitades son identicas, asi que el salto no se ve). */
  var cintas = [];
  [['.fv-cinta__pista', 34, 2.6], ['.fv-rotulo__pista', 46, 3.2]].forEach(function (par) {
    var el = document.querySelector(par[0]);
    if (!el) return;
    el.style.animation = 'none';
    cintas.push({ el: el, x: 0, w: el.scrollWidth / 2, base: par[1], fac: par[2] });
  });

  /* ---------- inclinación hacia el cursor ---------- */
  if (fino) {
    [].forEach.call(document.querySelectorAll('[data-vida-tilt]'), function (el) {
      var max = parseFloat(el.dataset.vidaTilt) || 6;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(900px) rotateY(' + (px * max).toFixed(2) +
                             'deg) rotateX(' + (-py * max).toFixed(2) + 'deg)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });

    /* ---------- botones que atraen el cursor ---------- */
    [].forEach.call(document.querySelectorAll('[data-vida-iman]'), function (el) {
      var r = null;
      el.addEventListener('pointerenter', function () { r = el.getBoundingClientRect(); });
      el.addEventListener('pointermove', function (e) {
        if (!r) r = el.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) * 0.22;
        var dy = (e.clientY - (r.top + r.height / 2)) * 0.28;
        el.style.transform = 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; r = null; });
    });
  }

  /* ---------- bucle ---------- */
  var ultimo = 0;
  function cuadro(t) {
    var dt = ultimo ? Math.min((t - ultimo) / 1000, 0.05) : 0.016;
    ultimo = t;

    // leer
    y = window.pageYOffset;
    vel += ((y - yAnt) - vel) * 0.2;
    yAnt = y;

    // escribir
    var doc = document.documentElement.scrollHeight - alto;
    barra.style.transform = 'scaleX(' + (doc > 0 ? Math.min(y / doc, 1) : 0).toFixed(4) + ')';

    for (var i = 0; i < cajas.length; i++) {
      var c = cajas[i];
      var centro = c.top + c.h / 2 - (y + alto / 2);
      if (Math.abs(centro) > alto * 1.6) continue;      // fuera de rango: no se toca
      var tr = 'translate3d(0,' + (-centro * c.f).toFixed(2) + 'px,0)';
      if (c.esc) {
        var pe = Math.min(Math.max((y - c.top) / c.h, 0), 1);
        tr += ' scale(' + (1 + pe * c.esc).toFixed(4) + ')';
      }
      c.el.style.transform = tr;
    }

    for (var j = 0; j < escenas.length; j++) {
      var s = escenas[j];
      if (s.top - y > alto * 1.5 || y - (s.top + s.h) > alto * 0.5) continue;
      var p = Math.min(Math.max((y - s.top) / s.h, 0), 1);
      var e2 = Math.min(Math.max((y + alto - s.top) / (alto * 0.85), 0), 1);
      if (Math.abs(p - s.p) > 0.002) { s.el.style.setProperty('--p', p.toFixed(3)); s.p = p; }
      if (Math.abs(e2 - s.e) > 0.002) { s.el.style.setProperty('--e', e2.toFixed(3)); s.e = e2; }
      // --se: como --e pero perseguido con retardo en cada cuadro. La rueda del
      // raton escribe --e a saltos; esto es lo que hace que el rotulo se
      // deslice como mantequilla en vez de dar tirones.
      if (s.sua) {
        s.se += (e2 - s.se) * 0.09;
        if (Math.abs(e2 - s.se) < 0.0006) s.se = e2;
        if (Math.abs(s.se - s.seW) > 0.0005) { s.el.style.setProperty('--se', s.se.toFixed(4)); s.seW = s.se; }
      }
    }

    for (var k = 0; k < cintas.length; k++) {
      var ci = cintas[k];
      ci.x -= (ci.base + Math.abs(vel) * ci.fac) * dt * (vel < -0.4 ? -1 : 1);
      if (ci.x <= -ci.w) ci.x += ci.w;
      if (ci.x > 0) ci.x -= ci.w;
      ci.el.style.transform = 'translate3d(' + ci.x.toFixed(2) + 'px,0,0)';
    }

    pendiente = false;
    requestAnimationFrame(cuadro);
  }

  medir();
  window.addEventListener('resize', medir, { passive: true });
  window.addEventListener('load', medir);
  requestAnimationFrame(cuadro);
})();
